import React from 'react';
import '../../styles/loader.css';

export const TextLogo = () => (
  <svg width={280} height={53} fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.402.928V25.68h.001V50.48c0 .744.042.788.772.788 2.534.002 5.068.002 7.601 0 .826 0 .874-.049.874-.855V.91c0-.843-.069-.911-.944-.911-2.465-.001-4.931 0-7.397 0-.875 0-.907.033-.907.928Zm-21.437 24.75V.983c0-.967.014-.98.958-.981H145.319c.822 0 .897.079.897.908v2.893l.001 4.848c0 .774.15.924.925.925 1.015.002 2.03.001 3.045.001h2.77c.76.002.932.172.933.93.003 1.867.002 3.736.002 5.604l-.001.812c0 .888-.044.932-.963.933h-5.509c-.8 0-1.201.393-1.202 1.18v30.91c0 .883-.448 1.325-1.344 1.325h-6.937c-.646 0-.969-.315-.97-.945V25.678h-.001ZM.019 29.769C.017 31.106.014 32.44.014 33.777v16.4c0 .73.358 1.094 1.074 1.094h7.398c.542 0 .813-.276.813-.826V27.22c0-.95 0-.952.974-.953.966-.002 1.932-.002 2.899-.002h.003c1.141 0 2.282 0 3.424-.002.643-.001.695-.046.696-.698.007-2.309.006-4.617 0-6.926 0-.674-.044-.711-.732-.712l-2.733-.003c-1.266 0-2.532 0-3.797-.005-.657-.003-.749-.116-.677-.756.234-2.092.869-4.025 2.226-5.683.937-1.144 2.13-1.944 3.467-2.498a8.178 8.178 0 0 1 3.076-.632c.523-.004.771-.29.773-.811.004-1.155.004-2.309.004-3.463 0-1.155 0-2.31.003-3.464.002-.42-.21-.573-.593-.59-1.7-.078-3.365.222-4.99.637-1.703.435-3.34 1.076-4.872 1.985a17.104 17.104 0 0 0-4.498 3.84c-.964 1.165-1.789 2.428-2.306 3.857l-.19.522c-.384 1.048-.77 2.102-.993 3.186-.396 1.928-.478 3.897-.46 5.874.027 3.282.021 6.564.016 9.846ZM229.47 40.46v-2.521h-.001c0-1.022-.001-2.043-.003-3.065-.004-2.374-.009-4.747.012-7.12a26.505 26.505 0 0 0-.509-5.31c-.205-1.055-.498-2.125-.955-3.094-1.338-2.839-3.333-5.359-5.888-7.195-7.001-5.032-17.545-4.749-24.214.644-1.54 1.245-2.775 2.75-3.786 4.464a16.55 16.55 0 0 0-2.003 5.279 26.19 26.19 0 0 0-.461 4.8c-.034 5.673-.029 11.347-.024 17.021l.003 6.048c0 .836.016.856.85.857 1.844.002 3.686.002 5.529.002h2.072c.556 0 .834-.286.834-.856v-4.518l.001-18.194c0-.492.002-.986.031-1.476.105-1.768.535-3.464 1.452-4.977 4.065-6.702 14.922-5.198 17.247 2.2.451 1.436.514 2.927.511 4.427-.01 5.538-.009 11.075-.007 16.612l.001 6c.001.522.267.783.798.783h1.699c1.984 0 3.968 0 5.953-.002.841-.001.857-.017.857-.854l.001-9.955ZM65.353 8.939c12.18-.06 21.945 9.874 21.858 21.7-.093 12.588-9.956 21.892-21.888 21.872-12.142-.021-21.824-9.474-21.887-21.882-.06-11.939 9.72-21.747 21.917-21.69ZM53.216 30.65c.13 3.878 1.715 7.743 4.53 10.305 5.332 4.857 14.062 3.672 17.661-2.658 2.25-3.956 2.85-8.7 1.237-13-2.975-7.925-13.088-10.66-19.448-4.835-2.85 2.61-4.107 6.406-3.98 10.188Zm209.898 3.057h-15.763c-.866 0-1.029.22-.783 1.036 1.19 3.96 3.953 7.386 7.938 8.768 3.162 1.097 6.695.796 9.572-.92 1.214-.723 2.273-1.612 3.144-2.699.35-.437.647-.915.945-1.393h.001c.238-.383.475-.764.74-1.126.193-.263.577-.546.877-.55 2.597-.036 5.195-.03 7.792-.023l.932.002c.44 0 .615.253.461.67-.652 1.76-1.412 3.463-2.451 5.044-3.404 5.184-9.045 8.785-15.183 9.686-10.649 1.564-21.015-5.257-24.141-15.494-.815-2.67-1.077-5.51-.652-8.275 1.417-9.22 8.069-16.983 17.287-19.005 6.37-1.397 13.204.367 18.25 4.447 4.082 3.302 6.996 8.36 7.692 13.62.138 1.043.175 2.101.211 3.156l.014.393c.014.4-.006.8-.025 1.202-.013.26-.026.522-.029.782-.006.445-.226.654-.655.668-.204.007-.408.009-.612.009h-15.56l-.002.002Zm-4.961-7.714v-.037h2.222c2.709 0 5.419.001 8.127-.003.27 0 .549-.012.805-.083.101-.028.238-.248.215-.348-.058-.258-.158-.507-.256-.754l-.038-.096a4.322 4.322 0 0 1-.041-.105c-1.936-5.032-7.135-8.313-12.714-7.378-4.518.756-7.755 3.84-9.371 7.789-.322.785-.243 1.015.598 1.015h10.453ZM129.847 37.976v12.477c0 .8-.01.815-.832.816-2.297.003-4.595.002-6.893.002h-.86c-.689 0-.707-.019-.707-.724l-.002-5.694c-.002-5.69-.004-11.38.009-17.069.004-1.486-.083-2.958-.527-4.373-2.406-7.664-13.797-8.856-17.486-1.581-1.59 3.137-1.442 7.026-1.304 10.649.037.996.075 1.972.075 2.907v15.066c0 .545-.273.819-.819.82h-2.074c-1.842 0-3.684 0-5.527-.002-.844-.001-.865-.025-.865-.843l-.003-6.099c-.002-2.44-.005-4.88-.004-7.32 0-1.162-.024-2.33-.049-3.502v-.002c-.077-3.663-.155-7.349.532-10.946 1.922-10.07 12.441-15.133 21.969-13.65 2.642.412 5.222 1.319 7.474 2.77.14.09.278.182.414.276 3.46 2.376 6.305 6.277 6.984 10.478.261 1.618.441 3.264.473 4.902.048 2.517.039 5.034.029 7.552a795.89 795.89 0 0 0-.008 3.091h.001Zm-107.47-3.438c.003 1.172.007 2.344.007 3.515h-.032v12.173c0 .695.358 1.043 1.074 1.043h7.398c.541 0 .812-.276.812-.826v-5.496c.002-5.757.003-11.514-.003-17.27-.003-2.075.276-4.068 1.247-5.953a8.5 8.5 0 0 1 3.042-3.335 9.275 9.275 0 0 1 4.51-1.425c.765-.041.808-.101.808-.846.003-2.157.002-4.313 0-6.469v-.02c0-.162 0-.327-.028-.487-.059-.343-.24-.56-.626-.516-.397.045-.797.08-1.196.114-.89.077-1.78.155-2.647.338-1.955.414-3.843 1.047-5.609 2.037-1.798 1.006-3.389 2.254-4.704 3.819-1.438 1.71-2.483 3.671-3.15 5.801-.517 1.653-.85 3.369-.877 5.096-.044 2.9-.035 5.802-.026 8.703v.004ZM184.61 50.372l.001-19.858h-.001l.001-6.636-.001-13.272c0-.896-.136-1.03-1.036-1.03h-7.293c-.781.001-.916.131-.916.922v40.02c0 .694.06.752.764.752h7.6c.844-.001.881-.04.881-.899Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h280v52.511H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const TextLogoLg = () => (
  <svg
    width="100%"
    height="203"
    viewBox="0 0 1080 203"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M610.981 3.58903V99.2728L610.983 99.2683C610.983 109.922 610.983 120.575 610.982 131.229V133.055C610.982 153.753 610.981 174.45 610.983 195.149C610.983 198.024 611.145 198.196 613.963 198.196C623.734 198.202 633.508 198.202 643.281 198.196C646.467 198.193 646.652 198.006 646.652 194.889V3.52352C646.652 0.264193 646.386 -7.74043e-05 643.011 -7.74043e-05C633.501 -0.00459484 623.989 -0.00233612 614.48 -7.74043e-05C611.102 0.00218131 610.981 0.126411 610.981 3.58903ZM528.296 99.2706V3.79456C528.296 0.0586381 528.35 0.00442929 531.988 0.00217057C534.705 0.00217057 537.422 0.0018018 540.14 0.00143303C546.932 0.000511105 553.725 -0.00041082 560.517 0.00442929C563.689 0.00668801 563.976 0.309356 563.976 3.51448C563.977 7.25491 563.977 10.9953 563.976 14.7358C563.976 20.9698 563.976 27.2039 563.98 33.438C563.98 36.4308 564.557 37.0113 567.547 37.0158C571.463 37.0217 575.379 37.0208 579.295 37.0199C582.855 37.0191 586.416 37.0183 589.977 37.0226C592.908 37.0271 593.573 37.6844 593.578 40.6139C593.588 47.8118 593.585 55.0113 593.583 62.2096V62.3174L593.582 65.4169C593.582 68.8501 593.411 69.0218 589.865 69.0241C585.142 69.0286 580.421 69.0271 575.699 69.0256C573.338 69.0248 570.977 69.0241 568.616 69.0241C565.531 69.0241 563.986 70.5442 563.98 73.5844V193.077C563.98 196.493 562.253 198.2 558.797 198.2H532.038C529.548 198.2 528.301 196.983 528.298 194.548V99.2683L528.296 99.2706ZM0.0736335 115.081C0.0649533 120.245 0.0562732 125.41 0.0562732 130.574V130.576V193.976C0.0562732 196.794 1.4368 198.202 4.19785 198.202C10.5372 198.204 16.8775 198.203 23.2182 198.203H23.2184H23.2187H23.2189H23.2192C26.3898 198.203 29.5605 198.202 32.7312 198.202C34.8234 198.199 35.8695 197.136 35.8695 195.011V105.227C35.8695 101.559 35.8718 101.547 39.6233 101.543C43.3505 101.538 47.0782 101.538 50.8062 101.538C55.2119 101.538 59.618 101.538 64.0241 101.529C66.5064 101.525 66.7048 101.351 66.7115 98.8324C66.7363 89.9059 66.7341 80.9817 66.7138 72.0553C66.7093 69.4487 66.5424 69.3064 63.8866 69.3019C60.3756 69.2943 56.8646 69.2939 53.3535 69.2935H53.3423C48.4612 69.2928 43.5801 69.2922 38.699 69.2725C36.1649 69.2612 35.8109 68.8231 36.0882 66.3498C36.9923 58.2635 39.4384 50.7895 44.6757 44.3792C48.2875 39.9589 52.8912 36.8667 58.0474 34.7232C61.7786 33.1715 65.7781 32.3154 69.9107 32.2815C71.9285 32.2634 72.8867 31.1612 72.8935 29.1442C72.9081 24.6812 72.9075 20.2188 72.907 15.7564C72.9064 11.2935 72.9059 6.83056 72.9205 2.36706C72.9273 0.745298 72.1111 0.151256 70.6344 0.083494C64.0737 -0.214657 57.6528 0.944065 51.383 2.54776C44.8155 4.2305 38.5051 6.70831 32.5937 10.2229C25.9248 14.1914 20.1554 19.1087 15.2451 25.0627C11.5251 29.5711 8.34394 34.4544 6.35093 39.977C6.10843 40.6492 5.86277 41.3216 5.61687 41.9947L5.61677 41.995C4.1367 46.0464 2.64807 50.1213 1.78775 54.3108C0.259181 61.7646 -0.0564534 69.3764 0.00892803 77.0199C0.116281 89.7063 0.094957 102.394 0.0736335 115.081ZM885.102 156.467L885.102 146.665L885.1 146.668C885.101 142.719 885.094 138.77 885.087 134.822C885.071 125.645 885.055 116.469 885.134 107.294C885.192 100.366 884.484 93.5221 883.172 86.7686C882.379 82.6871 881.249 78.5491 879.488 74.8041C874.328 63.829 866.633 54.0872 856.776 46.988C829.774 27.5382 789.102 28.6314 763.378 49.4794C757.439 54.2927 752.675 60.1112 748.775 66.736C745.01 73.1304 742.438 79.9766 741.051 87.1435C739.877 93.2217 739.308 99.5032 739.272 105.701C739.143 127.624 739.161 149.549 739.18 171.474V171.501C739.187 179.295 739.193 187.088 739.193 194.882C739.193 198.114 739.252 198.191 742.471 198.196C749.579 198.204 756.686 198.202 763.793 198.201C766.459 198.201 769.124 198.2 771.789 198.2C773.933 198.199 775.004 197.096 775.004 194.893L775.004 177.334C775.004 153.92 775.003 130.505 775.009 107.09C775.009 105.188 775.016 103.282 775.128 101.385C775.532 94.5498 777.191 87.9928 780.729 82.1472C796.409 56.2352 838.285 62.0514 847.253 90.6468C848.994 96.201 849.235 101.965 849.224 107.766C849.186 129.142 849.191 150.517 849.197 171.892V171.982C849.199 179.713 849.201 187.444 849.201 195.176C849.206 197.195 850.231 198.205 852.279 198.205C854.465 198.205 856.651 198.205 858.838 198.205C866.489 198.206 874.14 198.207 881.793 198.198C885.039 198.193 885.098 198.135 885.098 194.898C885.103 182.087 885.103 169.277 885.102 156.467ZM252.077 34.5561C299.059 34.3234 336.721 72.7284 336.385 118.447C336.027 167.111 297.984 203.077 251.96 202.998C205.126 202.919 167.782 166.375 167.541 118.409C167.309 72.254 205.034 34.3347 252.077 34.5561ZM205.264 118.49C205.767 133.481 211.879 148.42 222.732 158.327C243.302 177.101 276.974 172.523 290.857 148.05C299.533 132.756 301.852 114.418 295.628 97.7979C284.152 67.1561 245.144 56.5876 220.613 79.1047C209.622 89.1944 204.772 103.867 205.264 118.49ZM1014.87 130.308H954.068C950.729 130.308 950.1 131.157 951.047 134.312C955.64 149.617 966.295 162.865 981.666 168.209C993.863 172.449 1007.49 171.283 1018.59 164.651C1023.27 161.855 1027.36 158.42 1030.71 154.218C1032.06 152.529 1033.21 150.681 1034.36 148.831C1035.28 147.355 1036.2 145.877 1037.22 144.479C1037.96 143.46 1039.44 142.369 1040.6 142.353C1050.62 142.212 1060.64 142.237 1070.65 142.261C1071.85 142.264 1073.05 142.267 1074.25 142.27C1075.95 142.274 1076.62 143.25 1076.03 144.863C1073.51 151.668 1070.58 158.248 1066.57 164.362C1053.44 184.402 1031.69 198.322 1008.01 201.805C966.937 207.849 926.953 181.483 914.896 141.908C911.751 131.586 910.743 120.606 912.382 109.918C917.847 74.2756 943.506 44.264 979.058 36.4488C1003.63 31.0482 1029.99 37.8651 1049.45 53.6399C1065.2 66.4017 1076.44 85.9599 1079.12 106.291C1079.65 110.324 1079.8 114.415 1079.94 118.495C1079.95 119 1079.97 119.505 1079.99 120.01C1080.04 121.554 1079.97 123.1 1079.89 124.648V124.649V124.651V124.652V124.654V124.655V124.656V124.658C1079.84 125.666 1079.79 126.675 1079.78 127.683C1079.76 129.402 1078.91 130.21 1077.25 130.265C1076.47 130.292 1075.68 130.299 1074.89 130.299H1014.88L1014.87 130.308ZM995.732 100.483V100.343C998.586 100.343 1001.44 100.344 1004.29 100.344C1014.75 100.345 1025.2 100.346 1035.65 100.332C1036.69 100.332 1037.77 100.282 1038.76 100.009C1039.15 99.9007 1039.68 99.0492 1039.59 98.663C1039.36 97.6656 1038.98 96.702 1038.6 95.7444C1038.49 95.4875 1038.39 95.2311 1038.29 94.9745C1030.83 75.5201 1010.77 62.8374 989.253 66.4491C971.827 69.3742 959.342 81.2934 953.108 96.5601C951.866 99.5981 952.17 100.483 955.417 100.483H995.73H995.732ZM500.838 146.81V195.042C500.838 198.137 500.799 198.193 497.632 198.198C488.77 198.21 479.908 198.208 471.047 198.205L467.725 198.205C465.069 198.205 464.997 198.132 464.997 195.408C464.997 188.072 464.994 180.735 464.991 173.399V173.398V173.398V173.398V173.398V173.397C464.983 151.401 464.974 129.406 465.027 107.409C465.04 101.665 464.706 95.9751 462.993 90.5022C453.713 60.8746 409.775 56.2668 395.549 84.3901C389.414 96.5167 389.985 111.552 390.516 125.558C390.662 129.409 390.805 133.183 390.805 136.797V195.04C390.805 197.148 389.753 198.204 387.649 198.207C384.983 198.207 382.318 198.207 379.653 198.208H379.652H379.652H379.652H379.651H379.651C372.544 198.209 365.438 198.211 358.331 198.202C355.073 198.198 354.994 198.105 354.994 194.943C354.994 187.082 354.987 179.22 354.98 171.358C354.972 161.929 354.963 152.499 354.967 143.069C354.969 138.573 354.874 134.054 354.778 129.525V129.524V129.523V129.522V129.521V129.52C354.48 115.36 354.18 101.112 356.829 87.2045C364.242 48.2777 404.815 28.706 441.566 34.4386C451.756 36.0287 461.708 39.5342 470.397 45.1472C470.933 45.495 471.466 45.8496 471.993 46.211C485.338 55.3972 496.313 70.4787 498.93 86.7189C499.938 92.9755 500.632 99.3383 500.754 105.67C500.941 115.398 500.904 125.131 500.866 134.864V134.864V134.865V134.865V134.866V134.866C500.851 138.849 500.835 142.832 500.835 146.814L500.838 146.81ZM86.3103 133.519C86.3238 138.049 86.3372 142.579 86.3372 147.108H86.2177V194.166C86.2177 196.854 87.5983 198.198 90.3593 198.198H118.893C120.98 198.196 122.024 197.133 122.024 195.006C122.025 187.926 122.026 180.845 122.028 173.765V173.764C122.032 151.508 122.037 129.251 122.013 106.995C122.004 98.9724 123.079 91.2702 126.824 83.9836C129.613 78.5581 133.574 74.2575 138.559 71.0885C143.778 67.7705 149.672 65.9229 155.953 65.5818C158.904 65.4214 159.068 65.1888 159.071 62.3089C159.08 53.972 159.077 45.6373 159.071 37.3026L159.07 37.227C159.068 36.5985 159.066 35.9588 158.96 35.3421C158.735 34.014 158.038 33.1805 156.548 33.3476C155.015 33.5191 153.475 33.6535 151.934 33.7878L151.934 33.7879C148.502 34.0872 145.07 34.3866 141.724 35.0959C134.185 36.6951 126.903 39.1435 120.09 42.9675C113.155 46.8593 107.018 51.6839 101.945 57.7327C96.3992 64.3463 92.3681 71.9243 89.7957 80.1596C87.8004 86.5472 86.5153 93.1811 86.4139 99.8601C86.2437 111.073 86.277 122.289 86.3103 133.504L86.3103 133.519ZM712.074 194.729C712.076 169.139 712.076 143.55 712.076 117.961L712.074 117.964C712.074 109.412 712.074 100.861 712.075 92.3092C712.076 75.2062 712.077 58.1032 712.074 41.0002C712.074 37.5375 711.546 37.0226 708.077 37.0226H708.063C698.691 37.0203 689.317 37.018 679.944 37.0226C676.935 37.0248 676.414 37.5262 676.414 40.5823C676.409 92.1533 676.409 143.727 676.414 195.298C676.414 197.979 676.644 198.2 679.361 198.2C689.132 198.207 698.903 198.205 708.674 198.2C711.93 198.198 712.074 198.044 712.074 194.729Z"
      fill="#F5F5F0"
    />
  </svg>
);

export const Loader = () => (
  <svg viewBox="0 0 600 300" className="loader">
    <symbol id="s-text">
      <text textAnchor="middle" x="50%" y="50%" dy=".35em">
        Frontline
      </text>
    </symbol>
    <use className="text" xlinkHref="#s-text"></use>
    <use className="text" xlinkHref="#s-text"></use>
    <use className="text" xlinkHref="#s-text"></use>
    <use className="text" xlinkHref="#s-text"></use>
    <use className="text" xlinkHref="#s-text"></use>
  </svg>
);

export const CameraIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 8L12 3L7 8"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V15"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="36" height="36" rx="18" fill="white" />
    <path
      d="M20 24L14 18L20 12"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIconLg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="199" height="168" fill="none">
    <circle cx="115" cy="84" r="84" fill="#E0DEDA" />
    <g filter="url(#a)">
      <circle cx="84" cy="84" r="84" fill="#82DA9D" />
    </g>
    <path
      stroke="#E0DEDA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="13"
      d="M50 92.967 76.708 117 115 59"
    />
    <path
      stroke="#F5F5F0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="13"
      d="M47 92.967 73.708 117 112 59"
    />
    <defs>
      <filter
        id="a"
        width="168"
        height="168"
        x="0"
        y="0"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-18" dy="-16" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
        <feBlend in2="shape" result="effect1_innerShadow_722_1601" />
      </filter>
    </defs>
  </svg>
);

export const ChevronIcon = () => (
  <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 13L5.59317 8.06061C6.13561 7.47727 6.13561 6.52273 5.59317 5.93939L1 1"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReviewStar = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 1.5L6.236 3.80389L9 4.1756L7 5.96793L7.472 8.5L5 7.30389L2.528 8.5L3 5.96793L1 4.1756L3.764 3.80389L5 1.5Z"
      fill="#82DA9D"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReviewStarGray = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 1.5L6.236 3.80389L9 4.1756L7 5.96793L7.472 8.5L5 7.30389L2.528 8.5L3 5.96793L1 4.1756L3.764 3.80389L5 1.5Z"
      fill="#E0DEDA"
      stroke="#E0DEDA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookmarkOutline = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 19L8 14L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H13C13.5304 1 14.0391 1.21071 14.4142 1.58579C14.7893 1.96086 15 2.46957 15 3V19Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookmarkFilled = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="#82DA9D" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 19L8 14L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H13C13.5304 1 14.0391 1.21071 14.4142 1.58579C14.7893 1.96086 15 2.46957 15 3V19Z"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckNotDone = () => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_1508_4624)">
        <circle cx="22" cy="22" r="22" fill="#E0DEDA" />
      </g>
      <path
        d="M12 24.1989L18.9851 30L29 16"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_i_1508_4624"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-18" dy="-16" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1508_4624" />
        </filter>
      </defs>
    </svg>
  );
};

export const CheckDone = () => (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_1508_4607)">
      <circle cx="22" cy="22" r="22" fill="#82DA9D" />
    </g>
    <path
      d="M12 24.1989L18.9851 30L29 16"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_i_1508_4607"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-18" dy="-16" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1508_4607" />
      </filter>
    </defs>
  </svg>
);

export const RatingStarOutline = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99992 1.83398L10.0599 6.00732L14.6666 6.68065L11.3333 9.92732L12.1199 14.514L7.99992 12.3473L3.87992 14.514L4.66659 9.92732L1.33325 6.68065L5.93992 6.00732L7.99992 1.83398Z"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RatingStarFill = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="#82DA9D" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99992 1.83398L10.0599 6.00732L14.6666 6.68065L11.3333 9.92732L12.1199 14.514L7.99992 12.3473L3.87992 14.514L4.66659 9.92732L1.33325 6.68065L5.93992 6.00732L7.99992 1.83398Z"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Jobs = () => (
  <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99992 1.83398L1.33325 9.83398H7.33325L6.66659 15.1673L13.3333 7.16732H7.33325L7.99992 1.83398Z"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Clock = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.66667 15.1673C12.3486 15.1673 15.3333 12.1825 15.3333 8.50065C15.3333 4.81875 12.3486 1.83398 8.66667 1.83398C4.98477 1.83398 2 4.81875 2 8.50065C2 12.1825 4.98477 15.1673 8.66667 15.1673Z"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66675 4.5V8.5L11.3334 9.83333"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Award = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99992 10.4993C10.5772 10.4993 12.6666 8.41001 12.6666 5.83268C12.6666 3.25535 10.5772 1.16602 7.99992 1.16602C5.42259 1.16602 3.33325 3.25535 3.33325 5.83268C3.33325 8.41001 5.42259 10.4993 7.99992 10.4993Z"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.47341 9.76057L4.66675 15.8339L8.00008 13.8339L11.3334 15.8339L10.5267 9.75391"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ButtonPlus = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1621_9611)">
      <rect width="24" height="24" fill="#82DA9D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0001 10.9999L17.0001 10.9999L17.0001 12.9999L13.0001 12.9999L13.0001 17.0001H11.0001L11.0001 12.9999L7.00008 12.9999L7.00007 10.9999L11.0001 10.9999L11.0001 7.00008L13.0001 7.00008L13.0001 10.9999Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1621_9611">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Close = ({ color = 'white' }: { color?: string }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 1L1 9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 1L9 9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Search = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11ZM11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C12.5759 18 14.0302 17.4792 15.2001 16.6004C15.2281 16.6376 15.259 16.6733 15.2929 16.7071L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L16.7071 15.2929C16.6733 15.259 16.6376 15.2281 16.6004 15.2001C17.4792 14.0302 18 12.5759 18 11C18 7.13401 14.866 4 11 4Z"
      fill="black"
    />
  </svg>
);

export const Download = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15V3M12 15L17 10M12 15L7 10"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Calendar = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 2V6" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 2V6" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3 10H21"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Edit = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.33325 2.66602H2.66659C2.31296 2.66602 1.97382 2.80649 1.72378 3.05654C1.47373 3.30659 1.33325 3.64573 1.33325 3.99935V13.3327C1.33325 13.6863 1.47373 14.0254 1.72378 14.2755C1.97382 14.5255 2.31296 14.666 2.66659 14.666H11.9999C12.3535 14.666 12.6927 14.5255 12.9427 14.2755C13.1928 14.0254 13.3333 13.6863 13.3333 13.3327V8.66602"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3333 1.66617C12.5985 1.40095 12.9582 1.25195 13.3333 1.25195C13.7083 1.25195 14.068 1.40095 14.3333 1.66617C14.5985 1.93138 14.7475 2.29109 14.7475 2.66617C14.7475 3.04124 14.5985 3.40095 14.3333 3.66617L7.99992 9.9995L5.33325 10.6662L5.99992 7.9995L12.3333 1.66617Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditProfile = () => (
  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 3.0003C17.2626 2.73766 17.5744 2.52932 17.9176 2.38718C18.2608 2.24503 18.6286 2.17188 19 2.17188C19.3714 2.17187 19.7392 2.24503 20.0824 2.38718C20.4256 2.52932 20.7374 2.73766 21 3.0003C21.2626 3.26295 21.471 3.57475 21.6131 3.91791C21.7553 4.26107 21.8284 4.62887 21.8284 5.0003C21.8284 5.37174 21.7553 5.73953 21.6131 6.08269C21.471 6.42585 21.2626 6.73766 21 7.0003L7.5 20.5003L2 22.0003L3.5 16.5003L17 3.0003Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ViewProfile = () => (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.1404 22.1207C17.2604 22.3807 16.2204 22.5007 15.0004 22.5007H9.00035C7.78035 22.5007 6.74035 22.3807 5.86035 22.1207C6.08035 19.5207 8.75035 17.4707 12.0004 17.4707C15.2504 17.4707 17.9204 19.5207 18.1404 22.1207Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 2.5H9C4 2.5 2 4.5 2 9.5V15.5C2 19.28 3.14 21.35 5.86 22.12C6.08 19.52 8.75 17.47 12 17.47C15.25 17.47 17.92 19.52 18.14 22.12C20.86 21.35 22 19.28 22 15.5V9.5C22 4.5 20 2.5 15 2.5ZM12 14.67C10.02 14.67 8.42 13.06 8.42 11.08C8.42 9.10002 10.02 7.5 12 7.5C13.98 7.5 15.58 9.10002 15.58 11.08C15.58 13.06 13.98 14.67 12 14.67Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5799 11.08C15.5799 13.06 13.9799 14.67 11.9999 14.67C10.0199 14.67 8.41992 13.06 8.41992 11.08C8.41992 9.10002 10.0199 7.5 11.9999 7.5C13.9799 7.5 15.5799 9.10002 15.5799 11.08Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Trash = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 4H3.33333H14"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33325 4.00065V2.66732C5.33325 2.3137 5.47373 1.97456 5.72378 1.72451C5.97383 1.47446 6.31296 1.33398 6.66659 1.33398H9.33325C9.68687 1.33398 10.026 1.47446 10.2761 1.72451C10.5261 1.97456 10.6666 2.3137 10.6666 2.66732V4.00065M12.6666 4.00065V13.334C12.6666 13.6876 12.5261 14.0267 12.2761 14.2768C12.026 14.5268 11.6869 14.6673 11.3333 14.6673H4.66659C4.31296 14.6673 3.97382 14.5268 3.72378 14.2768C3.47373 14.0267 3.33325 13.6876 3.33325 13.334V4.00065H12.6666Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 7.33398V11.334"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33325 7.33398V11.334"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Upload = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 8L12 3L7 8"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V15"
      stroke="#173DE5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Crown = () => (
  <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.62528 17.1709C2.06914 17.2919 1.51772 16.9361 1.41023 16.3772L0.0191051 9.14333C-0.145809 8.28578 0.790583 7.64366 1.53111 8.10649L6.68123 11.3253C7.17113 11.6315 7.81781 11.4601 8.0917 10.9514L13.7054 0.525901C14.083 -0.175299 15.0888 -0.175301 15.4664 0.525899L21.0801 10.9514C21.354 11.4601 22.0007 11.6315 22.4906 11.3253L27.6407 8.10649C28.3812 7.64366 29.3176 8.28578 29.1527 9.14333L27.7616 16.3772C27.6541 16.9361 27.1027 17.2919 26.5465 17.1709C22.6928 16.3324 18.6909 15.8907 14.5859 15.8907C10.4809 15.8907 6.47905 16.3324 2.62528 17.1709Z"
      fill="url(#paint0_linear_1902_9859)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1902_9859"
        x1="0"
        y1="0"
        x2="15.0433"
        y2="25.5222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE563" />
        <stop offset="1" stop-color="#F5CA2F" />
      </linearGradient>
    </defs>
  </svg>
);

export const CheckboxChecked = () => (
  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="25" height="25" rx="6" fill="#173DE5" />
    <path d="M6.5 12L10.5 16L18.5 8" stroke="white" strokeWidth="2" />
  </svg>
);

export const CheckboxUnchecked = () => (
  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1.5"
      y="1.5"
      width="22.5"
      height="22.5"
      rx="6"
      fill="none"
      stroke="#173DE5"
      strokeWidth="2.5"
    />
  </svg>
);

export const MenuLightning = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuLogout = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 21H5M3 21V3M5 3H9"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path d="M16 17L21 12L16 7" stroke="white" strokeWidth="2" strokeLinecap="square" />
    <path
      d="M20 12H9"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export const MenuLock = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MenuLifeBuoy = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.92993 4.92969L9.16993 9.16969"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8301 14.8301L19.0701 19.0701"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8301 9.16969L19.0701 4.92969"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8301 9.17063L18.3601 5.64062"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.92993 19.0701L9.16993 14.8301"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MenuClipboard = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MenuBookmark = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MenuBook = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MenuAward = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.21 13.8909L7 23.0009L12 20.0009L17 23.0009L15.79 13.8809"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuAlertCircle = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V12"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <rect x="11" y="15" width="2" height="2" fill="white" />
  </svg>
);

export const LogoIcon = () => (
  <svg
    width="125"
    height="125"
    viewBox="0 0 125 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1901_7682)">
      <path d="M35.0342 22.3389V36.3339L89.9658 36.3913V22.3389H35.0342Z" fill="white" />
      <path
        d="M35.0342 52.1648V102.661H50.51V66.1237H78.9599V52.0713L35.0342 52.1648Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1901_7682">
        <rect
          width="54.9316"
          height="80.3223"
          fill="white"
          transform="translate(35.0342 22.3389)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const NavHome = ({ color }: { color: string }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.02 3.34016L3.63 7.54016C2.73 8.24016 2 9.73016 2 10.8602V18.2702C2 20.5902 3.89 22.4902 6.21 22.4902H17.79C20.11 22.4902 22 20.5902 22 18.2802V11.0002C22 9.79016 21.19 8.24016 20.2 7.55016L14.02 3.22016C12.62 2.24016 10.37 2.29016 9.02 3.34016Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.4902V15.4902"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NavProfile = ({ color }: { color: string }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.1404 22.1207C17.2604 22.3807 16.2204 22.5007 15.0004 22.5007H9.00035C7.78035 22.5007 6.74035 22.3807 5.86035 22.1207C6.08035 19.5207 8.75035 17.4707 12.0004 17.4707C15.2504 17.4707 17.9204 19.5207 18.1404 22.1207Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 2.5H9C4 2.5 2 4.5 2 9.5V15.5C2 19.28 3.14 21.35 5.86 22.12C6.08 19.52 8.75 17.47 12 17.47C15.25 17.47 17.92 19.52 18.14 22.12C20.86 21.35 22 19.28 22 15.5V9.5C22 4.5 20 2.5 15 2.5ZM12 14.67C10.02 14.67 8.42 13.06 8.42 11.08C8.42 9.10002 10.02 7.5 12 7.5C13.98 7.5 15.58 9.10002 15.58 11.08C15.58 13.06 13.98 14.67 12 14.67Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5799 11.08C15.5799 13.06 13.9799 14.67 11.9999 14.67C10.0199 14.67 8.41992 13.06 8.41992 11.08C8.41992 9.10002 10.0199 7.5 11.9999 7.5C13.9799 7.5 15.5799 9.10002 15.5799 11.08Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NavFind = ({ color }: { color: string }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 21.5C16.7467 21.5 21 17.2467 21 12C21 6.75329 16.7467 2.5 11.5 2.5C6.25329 2.5 2 6.75329 2 12C2 17.2467 6.25329 21.5 11.5 21.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 22.5L20 20.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NavPayment = ({ color }: { color: string }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 5.5L12 19.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3333 7.5H10.3333C9.71449 7.5 9.121 7.76339 8.68342 8.23223C8.24583 8.70107 8 9.33696 8 10C8 10.663 8.24583 11.2989 8.68342 11.7678C9.121 12.2366 9.71449 12.5 10.3333 12.5H13.6667C14.2855 12.5 14.879 12.7634 15.3166 13.2322C15.7542 13.7011 16 14.337 16 15C16 15.663 15.7542 16.2989 15.3166 16.7678C14.879 17.2366 14.2855 17.5 13.6667 17.5H8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NavMyGigs = ({ color }: { color: string }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 2.5V5.5"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2.5V5.5"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 13.5H15"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 17.5H12"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 4C19.33 4.18 21 5.45 21 10.15V16.33C21 20.45 20 22.51 15 22.51H9C4 22.51 3 20.45 3 16.33V10.15C3 5.45 4.67 4.19 8 4H16Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Verified = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.56931 1.3946C8.22687 1.15753 7.77335 1.15753 7.43091 1.3946L6.1807 2.2601C6.03935 2.35796 5.87515 2.41773 5.70397 2.43362L4.18992 2.57422C3.77521 2.61273 3.42779 2.90425 3.31785 3.30597L2.91648 4.7726C2.8711 4.93843 2.78373 5.08975 2.66281 5.21196L1.59336 6.29288C1.30043 6.58895 1.22168 7.03558 1.39568 7.41399L2.03094 8.79549C2.10277 8.95169 2.13311 9.12377 2.11904 9.29512L1.99459 10.8106C1.9605 11.2257 2.18726 11.6184 2.56379 11.7965L3.93844 12.4464C4.09387 12.5199 4.22772 12.6322 4.32708 12.7725L5.20587 14.0134C5.44657 14.3533 5.87274 14.5084 6.27561 14.4028L7.74644 14.0171C7.91274 13.9735 8.08747 13.9735 8.25377 14.0171L9.7246 14.4028C10.1275 14.5084 10.5536 14.3533 10.7943 14.0134L11.6731 12.7725C11.7725 12.6322 11.9063 12.5199 12.0618 12.4464L13.4364 11.7965C13.813 11.6184 14.0397 11.2257 14.0056 10.8106L13.8812 9.29512C13.8671 9.12377 13.8974 8.95169 13.9693 8.79549L14.6045 7.41399C14.7785 7.03558 14.6998 6.58895 14.4069 6.29288L13.6021 5.47946L8.37388 10.7076C7.99223 11.0893 7.37659 11.0992 6.98283 10.73L4.31617 8.23004C3.91325 7.85231 3.89284 7.21948 4.27057 6.81656C4.6483 6.41365 5.28114 6.39324 5.68405 6.77097L7.64433 8.60873L12.7393 3.51385L12.6824 3.30597C12.5724 2.90425 12.225 2.61273 11.8103 2.57422L10.2962 2.43362C10.1251 2.41773 9.96087 2.35796 9.81951 2.2601L8.56931 1.3946Z"
      fill="white"
    />
  </svg>
);

export const ArrowLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 12H5"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19L5 12L12 5"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckCircle = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 4L12 14.01L9 11.01"
      stroke="#82DA9D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7C12 9.76142 9.76142 12 7 12C4.23858 12 2 9.76142 2 7ZM7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C8.57591 14 10.0302 13.4792 11.2001 12.6004C11.2281 12.6376 11.259 12.6733 11.2929 12.7071L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L12.7071 11.2929C12.6733 11.259 12.6376 11.2281 12.6004 11.2001C13.4792 10.0302 14 8.57591 14 7C14 3.13401 10.866 0 7 0Z"
      fill="black"
    />
  </svg>
);

export const Settings = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MySkillsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProfileGigWishListIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProfileOnboardingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProfileLeaderBoardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.21 13.8909L7 23.0009L12 20.0009L17 23.0009L15.79 13.8809"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProfileGigAcademyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProfilePasswordIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProfileLogoutIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 21H5M3 21V3M5 3H9"
      stroke="white"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path d="M16 17L21 12L16 7" stroke="white" stroke-width="2" stroke-linecap="square" />
    <path
      d="M20 12H9"
      stroke="white"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProfileHelpIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.92969 4.92969L9.16969 9.16969"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8301 14.8301L19.0701 19.0701"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8301 9.16969L19.0701 4.92969"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8301 9.17063L18.3601 5.64062"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.92969 19.0701L9.16969 14.8301"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProfileLegalIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 8V12"
      stroke="white"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <rect x="11" y="15" width="2" height="2" fill="white" />
  </svg>
);

export const ProfileAvatarIcon = () => (
  <svg
    width="125"
    height="125"
    viewBox="0 0 125 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1621_9608)">
      <rect width="125" height="125" rx="62.5" fill="#F5F5F0" />
      <circle cx="62.5" cy="133.5" r="54.5" fill="#E0DEDA" />
      <circle cx="63" cy="48" r="27" fill="#E0DEDA" />
    </g>
    <rect x="2" y="2" width="121" height="121" rx="60.5" stroke="white" stroke-width="4" />
    <defs>
      <clipPath id="clip0_1621_9608">
        <rect width="125" height="125" rx="62.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SkillStatsIcon = () => (
  <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99967 1.83301L1.33301 9.83301H7.33301L6.66634 15.1663L13.333 7.16634H7.33301L7.99967 1.83301Z"
      stroke="#82DA9D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ClockStatsIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.66667 15.1663C12.3486 15.1663 15.3333 12.1816 15.3333 8.49967C15.3333 4.81778 12.3486 1.83301 8.66667 1.83301C4.98477 1.83301 2 4.81778 2 8.49967C2 12.1816 4.98477 15.1663 8.66667 15.1663Z"
      stroke="#82DA9D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.66699 4.5V8.5L11.3337 9.83333"
      stroke="#82DA9D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const AcheievementSatsIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99967 10.5003C10.577 10.5003 12.6663 8.41099 12.6663 5.83366C12.6663 3.25633 10.577 1.16699 7.99967 1.16699C5.42235 1.16699 3.33301 3.25633 3.33301 5.83366C3.33301 8.41099 5.42235 10.5003 7.99967 10.5003Z"
      stroke="#82DA9D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.47366 9.7596L4.66699 15.8329L8.00033 13.8329L11.3337 15.8329L10.527 9.75293"
      stroke="#82DA9D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const BackProfileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 12H5"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 19L5 12L12 5"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CrossIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 1L1 9"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 1L9 9"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const VerifiedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.56931 1.3946C8.22687 1.15753 7.77335 1.15753 7.43091 1.3946L6.1807 2.2601C6.03935 2.35796 5.87515 2.41773 5.70397 2.43362L4.18992 2.57422C3.77521 2.61273 3.42779 2.90425 3.31785 3.30597L2.91648 4.7726C2.8711 4.93843 2.78373 5.08975 2.66281 5.21196L1.59336 6.29288C1.30043 6.58895 1.22168 7.03558 1.39568 7.41399L2.03094 8.79549C2.10277 8.95169 2.13311 9.12377 2.11904 9.29512L1.99459 10.8106C1.9605 11.2257 2.18726 11.6184 2.56379 11.7965L3.93844 12.4464C4.09387 12.5199 4.22772 12.6322 4.32708 12.7725L5.20587 14.0134C5.44657 14.3533 5.87274 14.5084 6.27561 14.4028L7.74644 14.0171C7.91274 13.9735 8.08747 13.9735 8.25377 14.0171L9.7246 14.4028C10.1275 14.5084 10.5536 14.3533 10.7943 14.0134L11.6731 12.7725C11.7725 12.6322 11.9063 12.5199 12.0618 12.4464L13.4364 11.7965C13.813 11.6184 14.0397 11.2257 14.0056 10.8106L13.8812 9.29512C13.8671 9.12377 13.8974 8.95169 13.9693 8.79549L14.6045 7.41399C14.7785 7.03558 14.6998 6.58895 14.4069 6.29288L13.6021 5.47946L8.37388 10.7076C7.99223 11.0893 7.37659 11.0992 6.98283 10.73L4.31617 8.23004C3.91325 7.85231 3.89284 7.21948 4.27057 6.81656C4.6483 6.41365 5.28114 6.39324 5.68405 6.77097L7.64433 8.60873L12.7393 3.51385L12.6824 3.30597C12.5724 2.90425 12.225 2.61273 11.8103 2.57422L10.2962 2.43362C10.1251 2.41773 9.96087 2.35796 9.81951 2.2601L8.56931 1.3946Z"
      fill="white"
    />
  </svg>
);

export const PlusSymbolIcon = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.00008 3.99991L10.0001 3.9999L10.0001 5.9999L6.00008 5.99991L6.00008 10.0001H4.00008L4.00008 5.99992L7.91176e-05 5.99993L7.3217e-05 3.99993L4.00008 3.99992L4.00008 7.69627e-05L6.00008 7.64569e-05L6.00008 3.99991Z"
        fill="white"
      />
    </svg>
  );
};
